import React from "react";
import { Order } from "@/types";
import { useTranslation } from "react-i18next";
import { Grid } from "@mantine/core";
import Accordion from "@/components/organisms/AccordionDrawer";
import Text from "@/components/atoms/Text";

interface AccordionLogisticsProps {
  order: Order;
}

const AccordionLogistics = ({ order }: AccordionLogisticsProps) => {
  const { t } = useTranslation();
  return (
    <Accordion title={t("common:logistics")}>
      <Grid p={20}>
        <Grid.Col span={3}>
          <Text size="sm" color={"secondary"}>
            {t("enumerables:packaging")}
          </Text>
        </Grid.Col>
        <Grid.Col span={9}>
          <Text size="sm">{order.packaging ? t("enumerables:boxTypes." + order.packaging?.boxtype.name) : null}</Text>
        </Grid.Col>
        {order.estimatedDelivery && (
          <React.Fragment>
            <Grid.Col span={3}>
              <Text size="sm" color={"secondary"}>
                {t("common:estimatedDelivery")}
              </Text>
            </Grid.Col>
            <Grid.Col span={9}>
              <Text size="sm">{new Date(order.estimatedDelivery).toLocaleDateString()}</Text>
            </Grid.Col>
          </React.Fragment>
        )}
        {order.deliveryStart && (
          <React.Fragment>
            <Grid.Col span={3}>
              <Text size="sm" color={"secondary"}>
                {t("orders:deliveryStart")}
              </Text>
            </Grid.Col>
            <Grid.Col span={9}>
              <Text size="sm">{new Date(order.deliveryStart).toLocaleDateString()}</Text>
            </Grid.Col>
          </React.Fragment>
        )}
        {order.deliveryEnd && (
          <React.Fragment>
            <Grid.Col span={3}>
              <Text size="sm" color={"secondary"}>
                {t("orders:deliveryEnd")}
              </Text>
            </Grid.Col>
            <Grid.Col span={9}>
              <Text size="sm">{new Date(order.deliveryEnd).toLocaleDateString()}</Text>
            </Grid.Col>
          </React.Fragment>
        )}
      </Grid>
    </Accordion>
  );
};

export default AccordionLogistics;
